import moment from "moment";

export const RegistrationDetail = (props) => {
  const { data, step3, setStep3, step2, setStep2 } = props;

  return (
    <>
      <div>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <div className="mb-3">
              <label className="form-label">Registration Date</label>
              <input
                type="text"
                className="form-control border-dashed"
                id="steparrow-gen-info-email-input"
                value={
                  data.reg_date
                    ? moment(data.reg_date).format("D MMM, YYYY")
                    : "N/A"
                }
                readOnly
              />
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
            <div className="mb-3">
              <label className="form-label">Registration Number</label>
              <input
                type="text"
                className="form-control border-dashed"
                id="steparrow-gen-info-username-input"
                value={data.reg_no ? data.reg_no.toUpperCase() : "N/A"}
                readOnly
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                rows={5}
                className="form-control border-dashed"
                id="steparrow-gen-info-email-input"
                value={
                  data.detail_info ? data.detail_info.toUpperCase() : "N/A"
                }
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          class="btn btn-light btn-label"
          onClick={() => setStep2(!step2)}
        >
          <i class="bi bi-chevron-double-left label-icon align-middle fs-16 me-2"></i>{" "}
          Previous
        </button>
        <button
          type="button"
          class="btn btn-success btn-label right ms-auto"
          onClick={() => setStep3(!step3)}
        >
          <i className="bi bi-chevron-double-right label-icon align-middle fs-16 ms-2"></i>
          Next
        </button>
      </div>
    </>
  );
};
